import styled from 'styled-components';

export const NetworkPageStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
    padding-bottom: var(--space-6);

    .page-header {
        display: flex;
        flex-direction: column;
        gap: var(--space-1);
        margin-bottom: var(--space-2);
    }

    .page-title {
        margin: 0;
        font-size: var(--font-size-h3);
        font-weight: 600;
        line-height: 1.25;
        color: var(--color-white-95);
    }

    .page-desc {
        margin: 0;
        font-size: var(--font-size-md);
        color: var(--text-color-secondary);
    }
`;

export const NetworkSectionStyled = styled.section`
    padding: var(--space-5) var(--space-4);
    background: var(--color-surface);
    border-radius: var(--radius-md);

    .section-header {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: space-between;
        gap: var(--space-3) var(--space-6);
        margin-bottom: var(--space-5);
    }

    .section-heading {
        display: flex;
        flex-direction: column;
        gap: var(--space-1);
        min-width: 0;
    }

    .section-title {
        margin: 0;
        font-size: var(--font-size-h4);
        font-weight: 600;
        color: var(--color-white-95);
    }

    .section-desc {
        margin: 0;
        font-size: var(--font-size-md);
        color: var(--text-color-secondary);
    }

    .section-actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: var(--space-2);
        margin-top: var(--space-5);
    }
`;

export const NetworkFiltersRowStyled = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: var(--space-2);
    margin-bottom: var(--space-4);

    > * {
        flex: 1 1 160px;
        min-width: 0;
    }

    .filter-actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: var(--space-2);
        flex: 0 0 auto;
    }
`;

export const NetworkPresetsStyled = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--space-2) var(--space-4);
    margin-bottom: var(--space-4);

    .btn-link {
        height: auto;
        min-height: 0;
        padding: 0;
        font-size: var(--font-size-md);
        font-weight: 600;
        color: var(--text-color-secondary);
        border: none;
        border-bottom: 1px dashed var(--text-color-secondary);
        border-radius: 0;
        text-decoration: none;

        &:hover,
        &:focus {
            color: var(--color-white-95);
            border-bottom-color: var(--color-white-95);
            text-decoration: none;
            box-shadow: none;
        }
    }
`;

export const NetworkPartnerLabelStyled = styled.div`
    margin: 0 0 var(--space-3);

    .partner-name {
        margin: 0 0 var(--space-1);
        font-size: var(--font-size-h4);
        font-weight: 600;
        line-height: 1.3;
        color: var(--color-white-95);
    }

    .partner-meta {
        margin: 0;
        font-size: var(--font-size-md);
        color: var(--text-color-secondary);
    }
`;

export const NetworkInviteRowStyled = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--space-2);

    .form-control {
        flex: 1 1 240px;
        min-width: 0;
    }
`;

export const NetworkSearchRowStyled = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--space-2);
    margin-bottom: var(--space-3);

    .form-control {
        flex: 1 1 240px;
        min-width: 0;
    }
`;

export const NetworkTableWrapStyled = styled.div`
    overflow: auto;
    margin: 0 calc(-1 * var(--space-4));
    padding: 0 var(--space-4);
`;

export const NetworkTableStyled = styled.table`
    width: 100%;
    min-width: 760px;
    border-collapse: collapse;
    background: var(--color-surface-secondary);
    border-radius: var(--radius-md);
    overflow: hidden;

    th,
    td {
        padding: 14px 16px;
        text-align: left;
        vertical-align: middle;
        white-space: nowrap;
    }

    th {
        font-size: var(--font-size-xs);
        font-weight: 400;
        color: var(--color-white-60);
        border-bottom: 1px solid var(--color-surface);
    }

    td {
        font-size: var(--font-size-md);
        font-weight: 400;
        color: var(--color-white-95);
        border-top: 1px solid var(--color-surface);
    }

    tbody tr:first-child td {
        border-top: none;
    }

    tfoot td {
        font-weight: 600;
        color: var(--color-white-95);
        border-top: 1px solid var(--color-main);
        background: var(--color-surface-highlight);
    }

    .col-metric {
        text-align: right;
    }

    .col-money {
        text-align: right;
        font-weight: 600;
    }

    .empty-cell {
        padding: 32px 16px;
        text-align: center;
        color: var(--text-color-secondary);
        white-space: normal;
    }
`;
